import { useSelector } from 'react-redux';

import { selectIsMobile } from 'store/global/selectors';

import { DataDisplayVariant } from '../DataDisplay.constants';

export const useResponsiveDataDisplayVariant = () => {
  const isMobile = useSelector(selectIsMobile);

  return isMobile ? DataDisplayVariant.STYLE_E : DataDisplayVariant.STYLE_D;
};
